import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";

const DeletePersonDialog = ({
	open,
	onClose,
	onDelete,
}: {
	open: boolean;
	onClose: () => void;
	onDelete: () => void;
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			data-component="delete-person-dialog"
		>
			<DialogTitle id="alert-dialog-title" data-component="delete-dialog-title">
				{"Delete person from role?"}
			</DialogTitle>
			<DialogContent data-component="delete-dialog-content">
				<DialogContentText
					id="alert-dialog-description"
					data-component="delete-dialog-text"
				>
					Are you sure you want to delete person from assigment? This action
					is permanent and should only be used if a person is wrongfully
					placed in an assignment.
				</DialogContentText>
				<DialogActions data-component="delete-dialog-actions">
					<Button onClick={onClose} data-component="cancel-button">
						Cancel
					</Button>
					<Button
						onClick={onDelete}
						variant="contained"
						color="primary"
						autoFocus
						data-component="confirm-delete-button"
					>
						Yes, delete
					</Button>
				</DialogActions>
			</DialogContent>
		</Dialog>
	);
};

export default DeletePersonDialog;
